var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalkInWardrope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.69012H20.6338C21.1861 1.69012 21.6338 2.13784 21.6338 2.69012V21.6479C21.6338 22.2002 21.1861 22.6479 20.6338 22.6479H12M12 1.69012H3.36621C2.81393 1.69012 2.36621 2.13784 2.36621 2.69012V16.9704M12 1.69012V16.9704M12 22.6479H3.36621C2.81393 22.6479 2.36621 22.2002 2.36621 21.6479V16.9704M12 22.6479V16.9704M2.36621 16.9704H12M5.95252 19.7741H8.62467M13.1251 4.35365H16.9927M20.579 4.35365H16.9927M16.9927 4.35365V6.10597M16.9927 6.10597C16.9927 6.10597 14.0393 7.97745 14.0393 8.06857C14.0393 8.15969 19.9461 8.15969 19.9461 8.06857C19.9461 7.97745 16.9927 6.10597 16.9927 6.10597Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkInWardrope);
export default __webpack_public_path__ + "static/media/walk_in_wardrope.c074337a01137eb1496d6c5b93d6103e.svg";
export { ForwardRef as ReactComponent };